import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './RENT_Lease_Record.css';

const RENT_Lease_Record = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"RENT_LEASE_RECORD",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	RENT_LEASE_RECORD:-1
  });


  const [RENT_LEASE_RECORD, setRENT_LEASE_RECORD] = React.useState(null);
  const [RENT_LEASE_RECORD_D, setRENT_LEASE_RECORD_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Rental Income Lease Record');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/RENT_Lease_Record',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewRENT_LEASE_RECORD(clientInfo,"OpenNew");

		navigate('/RENT_Lease_Record',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Lease_Record_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(RENT_LEASE_RECORD));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutRENT_LEASE_RECORD(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostRENT_LEASE_RECORD(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewRENT_LEASE_RECORD(clientInfo,"OpenNew");
		}
		navigate('/RENT_Lease_Record',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Lease_Record_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Lease_Record_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Lease_Record_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(RENT_LEASE_RECORD));
		if(Temp_Data2.status!="New"){
			handleDeleteRENT_LEASE_RECORD(Temp_Data2);
			navigate('/RENT_Lease_Record#New',{replace:true});
		} 
		else 
			navigate('/RENT_Lease_Record',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Lease_Record',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Lease_Record',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Lease_Record',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Lease_Record',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!RENT_LEASE_RECORD) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_${i}_SECTION`;
	  const headerId = `#RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [RENT_LEASE_RECORD]) ;


  
  
  var Ids = [];
  for(var Ele in RENT_LEASE_RECORD){
	  for(var Sec in RENT_LEASE_RECORD[Ele]){
		if(Sec == "id")
			Ids.push(RENT_LEASE_RECORD[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(RENT_LEASE_RECORD[Ele]["status"]);
		else if(Array.isArray(RENT_LEASE_RECORD[Ele][Sec]))
			  for(var Row in RENT_LEASE_RECORD[Ele][Sec])  // Convert to RENT_LEASE_RECORD[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in RENT_LEASE_RECORD[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["RENT_LEASE_RECORD"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewRENT_LEASE_RECORD(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_LEASE_RECORD`).then((response1) => {
		if(!RENT_LEASE_RECORD) 
			setRENT_LEASE_RECORD(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_LEASE_RECORD_D`).then((response2) => {
			setRENT_LEASE_RECORD_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddRENT_LEASE_RECORD_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewRENT_LEASE_RECORD = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_LEASE_RECORD/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setRENT_LEASE_RECORD(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataRENT_LEASE_RECORD = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_LEASE_RECORD/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutRENT_LEASE_RECORD = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_LEASE_RECORD/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostRENT_LEASE_RECORD = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_LEASE_RECORD', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteRENT_LEASE_RECORD = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_LEASE_RECORD', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LEASE_RECORD));
	Temp_Data["1"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_0"]=value;
	//handleAddRENT_LEASE_RECORD(Temp_Data,App_Data['RENT_LEASE_RECORD']);
	Form_Data_onChange("1","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_0",value,Temp_Data);
 	//handleLastDataRENT_LEASE_RECORD(Temp_Data);
    setRENT_LEASE_RECORD(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LEASE_RECORD));
	Temp_Data["1"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_1"]=value;
	//handleAddRENT_LEASE_RECORD(Temp_Data,App_Data['RENT_LEASE_RECORD']);
	Form_Data_onChange("1","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_1",value,Temp_Data);
 	//handleLastDataRENT_LEASE_RECORD(Temp_Data);
    setRENT_LEASE_RECORD(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LEASE_RECORD));
	Temp_Data["1"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_2"]=value;
	//handleAddRENT_LEASE_RECORD(Temp_Data,App_Data['RENT_LEASE_RECORD']);
	Form_Data_onChange("1","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_2",value,Temp_Data);
 	//handleLastDataRENT_LEASE_RECORD(Temp_Data);
    setRENT_LEASE_RECORD(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LEASE_RECORD));
	Temp_Data["1"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_3"]=value;
	//handleAddRENT_LEASE_RECORD(Temp_Data,App_Data['RENT_LEASE_RECORD']);
	Form_Data_onChange("1","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_3",value,Temp_Data);
 	//handleLastDataRENT_LEASE_RECORD(Temp_Data);
    setRENT_LEASE_RECORD(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LEASE_RECORD));
	Temp_Data["1"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_4"]=value;
	//handleAddRENT_LEASE_RECORD(Temp_Data,App_Data['RENT_LEASE_RECORD']);
	Form_Data_onChange("1","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_4",value,Temp_Data);
 	//handleLastDataRENT_LEASE_RECORD(Temp_Data);
    setRENT_LEASE_RECORD(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LEASE_RECORD));
	Temp_Data["1"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_5"]=value;
	//handleAddRENT_LEASE_RECORD(Temp_Data,App_Data['RENT_LEASE_RECORD']);
	Form_Data_onChange("1","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_5",value,Temp_Data);
 	//handleLastDataRENT_LEASE_RECORD(Temp_Data);
    setRENT_LEASE_RECORD(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LEASE_RECORD));
	Temp_Data["2"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_0"]=value;
	Form_Data_onChange("2","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_0",value,Temp_Data);
    setRENT_LEASE_RECORD(Temp_Data);
  }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LEASE_RECORD));
	Temp_Data["2"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_1"]=value;
	Form_Data_onChange("2","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_1",value,Temp_Data);
    setRENT_LEASE_RECORD(Temp_Data);
  }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LEASE_RECORD));
	Temp_Data["2"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_2"]=value;
	//handleAddRENT_LEASE_RECORD(Temp_Data,App_Data['RENT_LEASE_RECORD']);
	Form_Data_onChange("2","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_2",value,Temp_Data);
 	//handleLastDataRENT_LEASE_RECORD(Temp_Data);
    setRENT_LEASE_RECORD(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LEASE_RECORD));
	Temp_Data["2"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_3"]=value;
	//handleAddRENT_LEASE_RECORD(Temp_Data,App_Data['RENT_LEASE_RECORD']);
	Form_Data_onChange("2","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_3",value,Temp_Data);
 	//handleLastDataRENT_LEASE_RECORD(Temp_Data);
    setRENT_LEASE_RECORD(Temp_Data);
 }; 
  

const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LEASE_RECORD));
	Temp_Data["2"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_4"]=value;
	Form_Data_onChange("2","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_4",value,Temp_Data);
 	//handleLastDataRENT_LEASE_RECORD(Temp_Data);
    setRENT_LEASE_RECORD(Temp_Data);
	//handleAddRENT_LEASE_RECORD(Temp_Data,App_Data['RENT_LEASE_RECORD']);
  }; 
  

    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LEASE_RECORD));
	Temp_Data["2"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_5"]=value;
	//handleAddRENT_LEASE_RECORD(Temp_Data,App_Data['RENT_LEASE_RECORD']);
	Form_Data_onChange("2","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_5",value,Temp_Data);
 	//handleLastDataRENT_LEASE_RECORD(Temp_Data);
    setRENT_LEASE_RECORD(Temp_Data);
 }; 
  

const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LEASE_RECORD));
	Temp_Data["3"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_3_0"]=value;
	Form_Data_onChange("3","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_3_0",value,Temp_Data);
 	//handleLastDataRENT_LEASE_RECORD(Temp_Data);
    setRENT_LEASE_RECORD(Temp_Data);
	//handleAddRENT_LEASE_RECORD(Temp_Data,App_Data['RENT_LEASE_RECORD']);
  }; 
  


const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LEASE_RECORD));
	Temp_Data["3"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_3_1"]=value;
	Form_Data_onChange("3","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_3_1",value,Temp_Data);
 	//handleLastDataRENT_LEASE_RECORD(Temp_Data);
    setRENT_LEASE_RECORD(Temp_Data);
	//handleAddRENT_LEASE_RECORD(Temp_Data,App_Data['RENT_LEASE_RECORD']);
  }; 
  

    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LEASE_RECORD));
	Temp_Data["4"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_4_0"]=value;
	//handleAddRENT_LEASE_RECORD(Temp_Data,App_Data['RENT_LEASE_RECORD']);
	Form_Data_onChange("4","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_4_0",value,Temp_Data);
 	//handleLastDataRENT_LEASE_RECORD(Temp_Data);
    setRENT_LEASE_RECORD(Temp_Data);
 }; 
  

const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LEASE_RECORD));
	Temp_Data["4"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_4_1"]=value;
	Form_Data_onChange("4","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_4_1",value,Temp_Data);
 	//handleLastDataRENT_LEASE_RECORD(Temp_Data);
    setRENT_LEASE_RECORD(Temp_Data);
	//handleAddRENT_LEASE_RECORD(Temp_Data,App_Data['RENT_LEASE_RECORD']);
  }; 
  


const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LEASE_RECORD));
	Temp_Data["9"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_0"]=value;
	Form_Data_onChange("9","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_0",value,Temp_Data);
 	//handleLastDataRENT_LEASE_RECORD(Temp_Data);
    setRENT_LEASE_RECORD(Temp_Data);
	//handleAddRENT_LEASE_RECORD(Temp_Data,App_Data['RENT_LEASE_RECORD']);
  }; 
  

    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LEASE_RECORD));
	Temp_Data["9"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_1"]=value;
	//handleAddRENT_LEASE_RECORD(Temp_Data,App_Data['RENT_LEASE_RECORD']);
	Form_Data_onChange("9","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_1",value,Temp_Data);
 	//handleLastDataRENT_LEASE_RECORD(Temp_Data);
    setRENT_LEASE_RECORD(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LEASE_RECORD));
	Temp_Data["9"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_2"]=value;
	//handleAddRENT_LEASE_RECORD(Temp_Data,App_Data['RENT_LEASE_RECORD']);
	Form_Data_onChange("9","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_2",value,Temp_Data);
 	//handleLastDataRENT_LEASE_RECORD(Temp_Data);
    setRENT_LEASE_RECORD(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LEASE_RECORD));
	Temp_Data["9"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_3"]=value;
	//handleAddRENT_LEASE_RECORD(Temp_Data,App_Data['RENT_LEASE_RECORD']);
	Form_Data_onChange("9","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_3",value,Temp_Data);
 	//handleLastDataRENT_LEASE_RECORD(Temp_Data);
    setRENT_LEASE_RECORD(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_LEASE_RECORD));
	Temp_Data["9"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_4"]=value;
	//handleAddRENT_LEASE_RECORD(Temp_Data,App_Data['RENT_LEASE_RECORD']);
	Form_Data_onChange("9","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_4",value,Temp_Data);
 	//handleLastDataRENT_LEASE_RECORD(Temp_Data);
    setRENT_LEASE_RECORD(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!RENT_LEASE_RECORD) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedRENT_LEASE_RECORD =JSON.parse(JSON.stringify(RENT_LEASE_RECORD));
  updatedRENT_LEASE_RECORD[Sec] = [...updatedRENT_LEASE_RECORD[Sec], newRow];
  setRENT_LEASE_RECORD(updatedRENT_LEASE_RECORD);
};

const handleDeleteRow = (sec,index) => {
  const updatedRENT_LEASE_RECORD = JSON.parse(JSON.stringify(RENT_LEASE_RECORD));
  updatedRENT_LEASE_RECORD[sec].splice(index, 1);
  setRENT_LEASE_RECORD(updatedRENT_LEASE_RECORD);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Rental Income Lease Record`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Rental Income Lease ID`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`RENT Lease ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_0" type="text" className="form-control" placeholder="RENT Lease ID" value={RENT_LEASE_RECORD["1"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_0`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter RENT Lease ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_1" type="text" className="form-control" placeholder="Asset ID" value={RENT_LEASE_RECORD["1"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_1`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Unit ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_2" type="text" className="form-control" placeholder="Unit ID" value={RENT_LEASE_RECORD["1"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_2`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Unit ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '120ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Tenant Name Masked`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_3" type="text" className="form-control" placeholder="Tenant Name Masked" value={RENT_LEASE_RECORD["1"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_3`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '120ch' }}>
						 {t(`Enter Tenant Name Masked`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Tenant Profile ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_4" type="text" className="form-control" placeholder="Tenant Profile ID" value={RENT_LEASE_RECORD["1"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_4`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_4_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Tenant Profile ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Unit Profile ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_5" type="text" className="form-control" placeholder="Unit Profile ID" value={RENT_LEASE_RECORD["1"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_5`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_5_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_1_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Unit Profile ID`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Lease Start Date`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_SECTION" className="row">
			                {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Lease Start Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_0" type="date"  value={RENT_LEASE_RECORD["2"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_0`]} 
							onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_0_Change} style={{ borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_0"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Lease Start Date
					  </div>
				  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Lease End Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_1" type="date"  value={RENT_LEASE_RECORD["2"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_1`]} 
							onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_1_Change} style={{ borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_1"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Lease End Date
					  </div>
				  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Monthly Rent USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_2" type="text" className="form-control" placeholder="Monthly Rent USD" value={RENT_LEASE_RECORD["2"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_2`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Monthly Rent USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Security Deposit USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_3" type="text" className="form-control" placeholder="Security Deposit USD" value={RENT_LEASE_RECORD["2"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_3`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_3_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Security Deposit USD`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Rent Escalation Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_4"  value={RENT_LEASE_RECORD["2"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_4`]} onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_4_Change} className="form-control" name="Rent Escalation Type"  >
						  <option value="None">None</option>
						  <option value="Fixed Percent">Fixed Percent</option>
						  <option value="Fixed Amount">Fixed Amount</option>
						  <option value="CPI Based">CPI Based</option>
						  <option value="Market Reset">Market Reset</option>
						  <option value="Other">Other</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Rent Escalation Type
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '25ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Rent Escalation Percentage`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_5" type="text" className="form-control" placeholder="Rent Escalation Percentage" value={RENT_LEASE_RECORD["2"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_5`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_5_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_2_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '25ch' }}>
						 {t(`Enter Rent Escalation Percentage`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Lease Status`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_3_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Lease Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_3_0"  value={RENT_LEASE_RECORD["3"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_3_0`]} onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_3_0_Change} className="form-control" name="Lease Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Expired">Expired</option>
						  <option value="Terminated">Terminated</option>
						  <option value="Month-to-Month">Month-to-Month</option>
						  <option value="In Default">In Default</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Lease Status
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Lease Renewal Option`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_3_1"  value={RENT_LEASE_RECORD["3"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_3_1`]} onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_3_1_Change} className="form-control" name="Lease Renewal Option"  >
						  <option value="None">None</option>
						  <option value="Tenant Option">Tenant Option</option>
						  <option value="Landlord Option">Landlord Option</option>
						  <option value="Mutual Option">Mutual Option</option>
						  <option value="Automatic Renewal">Automatic Renewal</option>
						  <option value="Unknown">Unknown</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Lease Renewal Option
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Lease Document Link`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_4_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Lease Document Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_4_0" type="text" className="form-control" placeholder="Lease Document Link" value={RENT_LEASE_RECORD["4"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_4_0`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Lease Document Link`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Lease Verification Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_4_1"  value={RENT_LEASE_RECORD["4"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_4_1`]} onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_4_1_Change} className="form-control" name="Lease Verification Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Verified">Verified</option>
						  <option value="Exception Found">Exception Found</option>
						  <option value="Rejected">Rejected</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Lease Verification Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_0"  value={RENT_LEASE_RECORD["9"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_0`]} onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_1" type="text" className="form-control" placeholder="Created By" value={RENT_LEASE_RECORD["9"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_1`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_2" type="text" className="form-control" placeholder="Created At" value={RENT_LEASE_RECORD["9"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_2`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_3" type="text" className="form-control" placeholder="Updated By" value={RENT_LEASE_RECORD["9"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_3`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_4" type="text" className="form-control" placeholder="Updated At" value={RENT_LEASE_RECORD["9"][`RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_4`]} 
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_LEASE_RECORD_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default RENT_Lease_Record;  